import {getUsers} from '@account/api';
import {useQuery} from '@tanstack/react-query';

export const useUsers = (
  {
    limit = 20,
    offset = 0,
    sort = 'email',
    descending = false,
    search = '',
    state = ['active'],
  },
  options = {}
) =>
  useQuery(
    ['users', {limit, offset, sort, descending, search, state}],
    () =>
      getUsers({
        limit,
        offset,
        sort,
        descending,
        search,
        state,
      }),
    {...options}
  );
